export const MODULE_ID = "VirtoCommerce.Quote";
export const ENABLED_KEY = "Quotes.EnableQuotes";
export const FILE_UPLOAD_SCOPE_NAME = "Quotes.FileUploadScopeName";
